/** @format */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { HomefieldPriceComponent } from './price.component';

@NgModule({
  imports: [CommonModule],
  declarations: [HomefieldPriceComponent],
  exports: [HomefieldPriceComponent],
})
export class HomefieldPriceModule {}
